import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Provider } from '../provider.model';
import { ProviderService } from '../provider.service';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { sortBy, get, lowerCase, map, chain, unescape } from 'lodash';
import { AppRoutingService } from '../../app-routing.service';
import { Encoder } from '../../../utils/encoder';
import { ProviderListResponse } from '../provider-list-reponse.model';

@Component({
  selector: 'app-provider-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ProviderListComponent implements OnInit {

  alerts: any = {
    newProviderAdded: {
      show: false,
      type: 'success',
      msg: 'Provider registered successfully'
    },
    providerUpdated: {
      show: false,
      type: 'success',
      msg: 'Provider updated successfully'
    },
    providerDeleted: {
      show: false,
      type: 'success',
      msg: 'Provider deleted successfully'
    },
    error: {
      show: false,
      type: 'danger',
      msg: 'An error occurred'
    }
  };

  showAlert: boolean;

  providerList: Array<Provider>;

  providerListResponse: ProviderListResponse;
  nextPageKey?: string;
  private previousUrl: string;

  constructor(private router: Router, private route: ActivatedRoute,
    private providerService: ProviderService, private routingService: AppRoutingService) {

    this.providerList = new Array<Provider>();
    this.showAlert = false;
  }

  ngOnInit() {
    this.alerts.newProviderAdded.show = this.providerService.hasJustRegistered;
    this.alerts.providerUpdated.show = this.providerService.hasJustUpdated;
    this.alerts.providerDeleted.show = this.providerService.hasJustDeleted;

    this.providerService.hasJustRegistered = false;
    this.providerService.hasJustUpdated = false;
    this.providerService.hasJustDeleted = false;
    this.getProviderList();
  }

  onClosed(dismissedAlert: any): void {
    dismissedAlert.show = false;
  }

  onLoadMoreClick(): void {
    if (this.nextPageKey) {
      this.loadMoreList();
    }
  }

  loadMoreList() {
    this.providerService.getProviderList(this.nextPageKey)
      .subscribe((res) => {
        this.providerListResponse = res;
        this.providerListResponse.items = chain(this.providerListResponse.items)
          .map(item => {
            item.providerName = Encoder.decode(item.providerName);
            item.providerDesc = Encoder.decode(item.providerDesc);
            return item;
          })
          .sortBy((item) => parseInt(item.providerId)).reverse().value();
        this.providerList = this.providerList.concat(this.providerListResponse.items);
        this.nextPageKey = this.providerListResponse.nextPageKey;
      }, err => {

      })
  }

  private getProviderList(): void {

    const data = this.route.snapshot.data;
    this.providerListResponse = get(data, ['providers'], []);
    this.providerList = this.providerListResponse.items;
    this.nextPageKey = this.providerListResponse.nextPageKey;
    this.providerList = chain(this.providerList)
      .map(item => {
        item.providerName = Encoder.decode(item.providerName);
        item.providerDesc = Encoder.decode(item.providerDesc);
        return item;
      })
      .sortBy((item) => parseInt(item.providerId)).reverse().value();

    if (this.providerList.length === 0) {
      this.showAlert = true;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/provider/list/list.component.ts